module.exports = __webpack_public_path__ + "img/Computer Science.629ce60a.jpg";